import { StyleSheet } from 'react-native';
import { tokens } from '../../../../constants';
import { checkIsPlatform } from '../../../../utils';
var getLegendAlignment = legendAlignment => {
  if (legendAlignment === 'end') return 'flex-end';
  if (legendAlignment === 'start') return 'flex-start';else return 'center';
};
export var getLegendStyles = (props, isSmallScreen) => {
  var _a, _b;
  var _props$legendPosition = props.legendPosition,
    legendPosition = _props$legendPosition === void 0 ? 'top' : _props$legendPosition,
    _props$legendAlignmen = props.legendAlignment,
    legendAlignment = _props$legendAlignmen === void 0 ? 'center' : _props$legendAlignmen,
    type = props.type,
    legendSpacing = props.legendSpacing,
    _props$legendsColumnN = props.legendsColumnNumber,
    legendsColumnNumber = _props$legendsColumnN === void 0 ? 2 : _props$legendsColumnN;
  var legendColNumber = isSmallScreen ? 1 : legendsColumnNumber;
  var topAndBottomLegendPosition = legendPosition == 'top' || legendPosition == 'bottom';
  var doughnutType = type == 'doughnut';
  return StyleSheet.create({
    container: Object.assign({
      flexDirection: topAndBottomLegendPosition ? 'row' : 'column',
      alignSelf: getLegendAlignment(legendAlignment)
    }, legendPosition === 'top' && {
      marginBottom: tokens.spacing.SPACING_28
    }),
    legendMargin: Object.assign({}, topAndBottomLegendPosition && {
      marginRight: legendSpacing ? (_a = tokens.spacing) === null || _a === void 0 ? void 0 : _a[legendSpacing] : tokens.spacing.SPACING_60
    }),
    legendMarginBottom: Object.assign(Object.assign({}, (!topAndBottomLegendPosition || doughnutType) && {
      marginBottom: legendSpacing ? (_b = tokens.spacing) === null || _b === void 0 ? void 0 : _b[legendSpacing] : tokens.spacing.SPACING_20
    }), !doughnutType && (legendPosition == 'right' ? {
      marginLeft: tokens.spacing.SPACING_60
    } : {
      marginRight: tokens.spacing.SPACING_60
    })),
    legendContainer: Object.assign({
      flexDirection: 'row',
      alignItems: 'center'
    }, doughnutType && !topAndBottomLegendPosition && {
      width: 100 / legendColNumber + "%"
    }),
    legendBox: {
      height: 16,
      width: 16,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_4,
      marginRight: tokens.spacing.SPACING_8
    },
    innerContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: tokens.spacing.SPACING_20
    },
    dounutLegendContainer: Object.assign(Object.assign(Object.assign({
      flexDirection: checkIsPlatform('web') ? 'row' : 'column'
    }, checkIsPlatform('web') && {
      flex: 1,
      flexWrap: topAndBottomLegendPosition && !doughnutType ? 'nowrap' : 'wrap'
    }), {
      marginTop: tokens.spacing.SPACING_20,
      alignSelf: topAndBottomLegendPosition ? 'center' : 'auto'
    }), legendPosition == 'right' ? {
      marginLeft: tokens.spacing.SPACING_32
    } : legendPosition == 'left' ? {
      marginRight: tokens.spacing.SPACING_32
    } : '')
  });
};